import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { InviteUsersModal } from '@modules/users/components/InviteUsersModal/InviteUsersModal';
import { trackUserManagementEvents } from '@modules/workspaceSettings/utils';
import { GroupAddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';

export const InviteUsersFromWorkspaceSettings = () => {
  const { openModal } = useMuiModalContext();

  const openInviteUsersModel = () => {
    openModal({
      contentComponent: () => <InviteUsersModal shouldFetchUsers={false} />,
      modalProps: {
        maxWidth: 'md',
        fullWidth: true,
        PaperProps: {
          elevation: 3,
        },
      },
    });
    trackUserManagementEvents({
      eventName:
        'User Management - Invite Users: Opened Modal From Workspace Settings',
    });
  };

  return (
    <Button
      startIcon={<GroupAddRounded />}
      variant="contained"
      onClick={openInviteUsersModel}
    >
      Invite
    </Button>
  );
};
